export interface BotAdvCustomizationFormProps {
  name?: string;
  sortBy?: string;
  autoDownload?: string | boolean;
  downloadLimit?: number | null;
  harvestingInterval?: string | number;
  intervalUnit?: string | number;
  intervalType?: string;
  stopAfter?: string | number;
  stopAfterUnit?: string | number;
  stopAfterType?: string | number;
  enableDesktopNotification?: string;
  enableAppNotification?: string;
  enableEmail?: string;
  enableDnd?: string;
  notification?: string;
  downloadCriteria?: string;
  skills?: string[];
}

export const profiles = [
  {
    label: 'Activity',
    value: 'activityDate',
  },
  {
    label: 'Date resume last updated',
    value: 'dateResumeLastUpdated',
  },
];

export const downloadSettings = [
  {
    label: 'Auto Download',
    value: true,
  },
  {
    label: 'Manual',
    value: false,
  },
];

export const sourceAfter = [
  {
    label: '1 Hr',
    value: '1-HOUR',
  },
  {
    label: '2 Hr',
    value: '2-HOUR',
  },
  {
    label: '4 Hr',
    value: '4-HOUR',
  },
  {
    label: '1 Day',
    value: '1-DAY',
  },
];

export const stopAfter = [
  {
    label: '6 Hr',
    value: '6-HOUR',
  },
  {
    label: '12 Hr',
    value: '12-HOUR',
  },
  {
    label: '1 Day',
    value: '1-DAY',
  },
  {
    label: '2 Days',
    value: '2-DAY',
  },
  {
    label: '3 Days',
    value: '3-DAY',
  },
  {
    label: '5 Days',
    value: '5-DAY',
  },
  {
    label: '8 Days',
    value: '8-DAY',
  },
  {
    label: 'Custom',
    value: 'CUSTOM',
  },
];

export const notifyVia = [
  {
    label: 'Desktop Notification',
    value: 'DESKTOP',
  },
  {
    label: 'App Notification',
    value: 'APP',
  },
  {
    label: 'Email',
    value: 'EMAIL',
  },
];

export const timeTypeDropDownOptions = [
  { label: 'Hours', value: 'HOUR' },
  { label: 'Days', value: 'DAY' },
];

export const setAdditionalFieldOnRequest = (harvestBotCustomObj) => {
  switch (harvestBotCustomObj.notification) {
    case 'DESKTOP':
      harvestBotCustomObj.enableDesktopNotification = true;
      harvestBotCustomObj.enableAppNotification = false;
      harvestBotCustomObj.enableEmail = false;
      break;
    case 'APP':
      harvestBotCustomObj.enableDesktopNotification = false;
      harvestBotCustomObj.enableAppNotification = true;
      harvestBotCustomObj.enableEmail = false;
      break;
    case 'EMAIL':
      harvestBotCustomObj.enableDesktopNotification = false;
      harvestBotCustomObj.enableAppNotification = false;
      harvestBotCustomObj.enableEmail = true;
      break;
  }
  return harvestBotCustomObj;
};
export const filterList = [
  {
    id: 1,
    label: 'All Bots',
    value: 'all',
  },
  {
    id: 2,
    label: 'Active Bots',
    value: 'active',
  },
  {
    id: 3,
    label: 'Inactive Bots',
    value: 'inactive',
  },
];

export const jobBoardfilterList = [
  {
    id: 1,
    label: 'All Job Boards',
    value: 'all',
  },
  {
    id: 2,
    label: 'Dice',
    value: 'DICE_SEARCH',
  },
  {
    id: 3,
    label: 'Career Builder RDB',
    value: 'CAREER_BUILDER',
  },
  {
    id: 4,
    label: 'Career Builder Edge',
    value: 'CAREER_BUILDER_EDGE',
  },
  {
    id: 5,
    label: 'Tech Fetch',
    value: 'TECH_FETCH',
  },
];
